(function (global) {
  'use strict';

  var RELOAD_KEY = 'bee_hive_dashboard_session_reload';

  var STATUS_LABELS = {
    loading: 'Checking Bee Hive access',
    logged_out: 'Bee Hive partner program',
    public_funnel: 'Bee Hive partner program',
    pending: 'Application under review',
    activation_required: 'Activation required',
    rejected: 'Application not approved',
    denied: 'Access denied',
    status_check: 'Checking Bee Hive status',
    authorized: 'Dashboard data found',
    editor: 'Dashboard data found',
    session_pending: 'Checking Bee Hive access',
  };

  function init(cfg) {
    cfg = cfg || {};
    var gate = document.getElementById(cfg.gateId);
    var denied = document.getElementById(cfg.deniedId);
    var content = document.getElementById(cfg.contentId);
    var status = document.getElementById(cfg.statusId);

    setStatus(status, STATUS_LABELS.loading, 'loading');

    if (cfg.editorBypass) {
      applyLiquidState(cfg, gate, denied, content, status);
      return;
    }

    if (cfg.liquidLoggedIn) {
      routeLoggedIn(cfg, gate, denied, content, status);
      return;
    }

    if (!global.MuskleAccountSession || !global.MuskleAccountSession.probe) {
      redirect(cfg.infoHref || '/pages/bee-hive-info');
      return;
    }

    global.MuskleAccountSession.probe()
      .then(function (loggedIn) {
        if (!loggedIn) {
          redirect(cfg.infoHref || '/pages/bee-hive-info');
          return;
        }

        if (!sessionStorage.getItem(RELOAD_KEY)) {
          sessionStorage.setItem(RELOAD_KEY, '1');
          setStatus(status, STATUS_LABELS.session_pending, 'session_pending');
          var sync = global.MuskleAccountSession.syncStorefrontSession;
          if (sync) {
            sync().finally(function () {
              global.location.reload();
            });
            return;
          }
          global.location.reload();
          return;
        }

        redirect(cfg.infoHref || '/pages/bee-hive-info');
      })
      .catch(function () {
        redirect(cfg.infoHref || '/pages/bee-hive-info');
      });
  }

  function routeLoggedIn(cfg, gate, denied, content, status) {
    var state = cfg.accessState || 'public_funnel';

    if (state === 'authorized' || state === 'editor') {
      applyLiquidState(cfg, gate, denied, content, status);
      return;
    }

    if (state === 'activation_required') {
      redirect(cfg.setupHref || '/pages/bee-hive-setup');
      return;
    }

    if (state === 'pending' || state === 'rejected' || state === 'denied') {
      applyLiquidState(cfg, gate, denied, content, status);
      return;
    }

    if (state === 'public_funnel') {
      if (cfg.memberToken && cfg.customerId && cfg.apiBase) {
        refineWithMemberStatus(cfg, gate, denied, content, status);
        return;
      }
      redirect(cfg.infoHref || '/pages/bee-hive-info');
      return;
    }

    if (state === 'status_check') {
      refineWithMemberStatus(cfg, gate, denied, content, status);
      return;
    }

    redirect(cfg.infoHref || '/pages/bee-hive-info');
  }

  function refineWithMemberStatus(cfg, gate, denied, content, status) {
    var apiBase = String(cfg.apiBase || '').replace(/\/$/, '');
    if (!apiBase || !cfg.memberToken || !cfg.customerId) {
      redirect(cfg.infoHref || '/pages/bee-hive-info');
      return;
    }

    fetch(apiBase + '/api/public/member-bee-hive-status', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        shopify_customer_id: cfg.customerId,
        member_status_token: cfg.memberToken,
        email: cfg.customerEmail || '',
      }),
    })
      .then(function (res) {
        return res.json().catch(function () {
          return {};
        });
      })
      .then(function (data) {
        if (!data || !data.ok) {
          redirect(cfg.infoHref || '/pages/bee-hive-info');
          return;
        }

        if (data.state === 'ACTIVATED') {
          redirect(cfg.memberHubHref || '/pages/mijn-muskle');
          return;
        }
        if (data.state === 'APPROVED_ACTIVATION_REQUIRED') {
          redirect(cfg.setupHref || '/pages/bee-hive-setup');
          return;
        }
        if (data.state === 'APPLICATION_RECEIVED') {
          showRoute(
            gate,
            denied,
            content,
            status,
            'pending',
            'Application under review',
            'MUSKLE is reviewing your Bee Hive application. No action is required — you will receive an email after review.',
            cfg.memberHubHref || '/pages/mijn-muskle',
            'View status in Mijn MUSKLE'
          );
          return;
        }
        if (data.state === 'REJECTED') {
          showRoute(
            gate,
            denied,
            content,
            status,
            'rejected',
            'Application not approved',
            'This Bee Hive application was not approved. Contact Bee Hive support if you need help.',
            cfg.memberHubHref || '/pages/mijn-muskle',
            'Open Mijn MUSKLE'
          );
          return;
        }
        redirect(cfg.infoHref || '/pages/bee-hive-info');
      })
      .catch(function () {
        redirect(cfg.infoHref || '/pages/bee-hive-info');
      });
  }

  function applyLiquidState(cfg, gate, denied, content, status) {
    var state = cfg.accessState || 'logged_out';

    if (state === 'authorized' || state === 'editor') {
      hide(gate);
      hide(denied);
      show(content);
      setStatus(status, STATUS_LABELS[state] || STATUS_LABELS.authorized, state);
      sessionStorage.removeItem(RELOAD_KEY);
      return;
    }

    hide(gate);
    show(denied);
    hide(content);
    ensureDeniedCopy(denied);
    setStatus(status, STATUS_LABELS[state] || STATUS_LABELS.denied, state);
    sessionStorage.removeItem(RELOAD_KEY);
  }

  function showRoute(gate, denied, content, status, state, heading, message, href, label) {
    hide(gate);
    show(denied);
    hide(content);
    setDeniedCopy(denied, heading, message);
    setDeniedCta(denied, href, label);
    setStatus(status, STATUS_LABELS[state] || heading, state);
    sessionStorage.removeItem(RELOAD_KEY);
  }

  function redirect(url) {
    if (!url) return;
    try {
      sessionStorage.removeItem(RELOAD_KEY);
    } catch (e) {}
    global.location.replace(url);
  }

  function ensureDeniedCopy(denied) {
    if (!denied) return;
    var heading = denied.querySelector('h2');
    var message = denied.querySelector('p');
    if (heading && !heading.textContent.trim()) {
      heading.textContent = 'Bee Hive';
    }
    if (message && !message.textContent.trim()) {
      message.textContent = 'Bee Hive is the MUSKLE partner program. This page is only for activated Bee Hive partners.';
    }
  }

  function setDeniedCopy(denied, heading, message) {
    if (!denied) return;
    var headingEl = denied.querySelector('h2');
    var messageEl = denied.querySelector('p');
    if (headingEl) headingEl.textContent = heading;
    if (messageEl) messageEl.textContent = message;
  }

  function setDeniedCta(denied, href, label) {
    if (!denied || !href) return;
    var link = denied.querySelector('a.bee-dashboard__btn--primary');
    if (link) {
      link.setAttribute('href', href);
      if (label) link.textContent = label;
    }
  }

  function setStatus(statusEl, label, state) {
    if (!statusEl) return;
    statusEl.textContent = label;
    statusEl.setAttribute('data-bee-status-state', state || '');
  }

  function show(el) {
    if (!el) return;
    el.classList.remove('hidden');
  }

  function hide(el) {
    if (!el) return;
    el.classList.add('hidden');
  }

  global.BeeHiveDashboardBridge = { init: init };
})(window);
